<template>
    <div class="fm-grid">
        <v-layout v-if="singleFileView" vrow wrap class="fm-grid-row">
            <!--TRAVERSE UP-->
            <v-flex sm2 class="fm-item-card-container text-center pr-4 pb-5">
                <v-hover v-slot:default="{ hover }">
                    <v-card class="fm-item-card" :elevation="hover ? 4 : 0  ">
                        <v-responsive :aspect-ratio="1/1" v-on:click="returnToFileManager">
                            <div class="fm-item-icon">
                                <span class="fa-stack bg-fa-folder">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-stack-1x far fa-stack-1x fa-inverse fa-folder"></i>
                    </span>
                            </div>
                        </v-responsive>
                    </v-card>
                </v-hover>
                <div class="fm-item-info">File Manager</div>
            </v-flex>

            <!--FILES-->
            <v-flex sm2 class="fm-item-card-container text-center  pr-4 pb-5"
                    v-for="(file, index) in filteredFiles"
                    v-bind:key="`f-${index}`"
                    v-bind:title="file.basename"
                    v-bind:class="{'active': checkSelect('files', file.path)}"
            >
                <v-hover v-slot:default="{ hover }">
                    <v-card class="fm-item-card" :elevation="hover ? 4 : 0">
                        <v-responsive :aspect-ratio="1/1"  v-on:click="selectItem('files', file.path, $event)">

                            <div class="fm-item-icon" style="text-align: center;">
                                <!--<i v-if="acl && file.acl === 0" class="fas fa-unlock-alt fa-5x pb-2"></i>-->
                                <v-btn v-show="hover" color="primary" v-on:click="downloadFile(file, $event)">
                                    Download
                                </v-btn>
                                <thumbnail v-show="!hover" v-if="thisImage(file.extension)"
                                           v-bind:disk="disk"
                                           v-bind:file="file">
                                </thumbnail>
                                <!--<i v-else class="far fa-5x pb-2"-->
                                <!--v-bind:class="extensionToIcon(file.extension)"></i>-->
                                <span v-show="!hover"  v-else class="fa-stack" v-bind:class="'bg-'+extensionToIcon(file.extension)">
                                  <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fas fa-stack-1x fa-inverse" v-bind:class="extensionToIcon(file.extension)"></i>
                                </span>
                            </div>
                            <div class="fm-grid-actions">
                                <v-btn @click="contextMenu(file, $event)" icon>
                                    <v-icon color="primary">more_vert</v-icon>
                                </v-btn>
                            </div>
                        </v-responsive>
                    </v-card>
                </v-hover>
                <div class="fm-item-info">
                    <!-- {{ `${file.filename}.${file.extension}` }} -->
                    {{ file.basename }}
                    <!--<br>-->
                    <!--{{-- bytesToHuman(file.size) --}}-->
                </div>
            </v-flex>
        </v-layout>
        <v-layout v-else vrow wrap class="fm-grid-row">
            <!--TRAVERSE UP-->
            <v-flex sm2 v-if="!isRootPath"  class="fm-item-card-container text-center pr-4 pb-5">
                <v-hover v-slot:default="{ hover }">
                    <v-card class="fm-item-card" :elevation="hover ? 4 : 0  ">
                        <v-responsive :aspect-ratio="1/1" v-on:click="levelUp">
                            <div class="fm-item-icon">
                                <!--<i class="fas fa-level-up-alt fa-5x pb-2"></i>-->
                                <span class="fa-stack bg-fa-level-up-alt">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-stack-1x fa-level-up-alt"></i>
                    </span>
                            </div>
                        </v-responsive>
                    </v-card>
                </v-hover>
                <div class="fm-item-info">Previous Folder</div>
            </v-flex>

            <!--LISTINGS-->
            <v-flex sm2 class="fm-item-card-container text-center unselectable  pr-4 pb-5"
                    v-for="(directory, index) in listings"
                    v-bind:key="`l-${index}`"
                    v-bind:title="directory.basename"
                    v-bind:class="{'active': checkSelect('directories', directory.path)}"
            >
                <v-hover v-slot:default="{ hover }">
                    <v-card class="fm-item-card" :elevation="hover ? 4 : 0">
                        <v-responsive :aspect-ratio="1/1" v-on:click="selectDirectory(directory.path)"
                                      v-on:dblclick.stop="selectDirectory(directory.path)"
                        >
                            <div class="fm-item-icon">
                                <!--<i class="fa-5x pb-2"-->
                                <!--v-bind:class="(acl && directory.acl === 0) ? 'fas fa-unlock-alt' : 'far fa-folder'"></i>-->
                                <span class="fa-stack bg-fa-list">
                              <i class="fas fa-circle fa-stack-2x"></i>
                              <i class="fas fa-stack-1x fa-inverse fa-list"></i>
                            </span>
                            </div>
                            <!--<div class="fm-grid-actions"> <v-btn @click.stop="contextMenu(directory, $event)" icon>-->
                            <!--<v-icon color="primary">more_vert</v-icon>-->
                            <!--</v-btn></div>-->
                        </v-responsive>
                    </v-card>
                </v-hover>
                <div class="fm-item-info">
                    {{ directory.basename }}
                </div>
            </v-flex>

            <!--FOLDERS-->
            <v-flex sm2 class="fm-item-card-container text-center unselectable  pr-4 pb-5"
                    v-for="(directory, index) in directories"
                    v-bind:key="`d-${index}`"
                    v-bind:title="directory.basename"
                    v-bind:class="{'active': checkSelect('directories', directory.path)}"
            >
                <v-hover v-slot:default="{ hover }">
                    <v-card class="fm-item-card" :elevation="hover ? 4 : 0">
                        <v-responsive :aspect-ratio="1/1" v-on:click="selectDirectory(directory.path)"
                                      v-on:dblclick.stop="selectDirectory(directory.path)"
                        >
                            <div class="fm-item-icon">
                                <!--<i class="fa-5x pb-2"-->
                                <!--v-bind:class="(acl && directory.acl === 0) ? 'fas fa-unlock-alt' : 'far fa-folder'"></i>-->
                                <span class="fa-stack bg-fa-folder">
                              <i class="fas fa-circle fa-stack-2x"></i>
                              <i class="fas fa-stack-1x fa-inverse fa-folder"></i>
                            </span>
                            </div>
                            <div class="fm-grid-actions"> <v-btn v-if="!directory.locked" @click.stop="contextMenu(directory, $event)" icon>
                                <v-icon color="primary">more_vert</v-icon>
                            </v-btn></div>
                        </v-responsive>
                    </v-card>
                </v-hover>
                <div class="fm-item-info">
                    {{ directory.basename }}
                </div>
            </v-flex>

            <!--FILES-->
            <v-flex sm2 class="fm-item-card-container text-center  pr-4 pb-5"
                    v-for="(file, index) in files"
                    v-bind:key="`f-${index}`"
                    v-bind:title="file.basename"
                    v-bind:class="{'active': checkSelect('files', file.path)}"
            >
                <v-hover v-slot:default="{ hover }">
                    <v-card class="fm-item-card" :elevation="hover ? 4 : 0">
                        <v-responsive :aspect-ratio="1/1"  v-on:click="selectItem('files', file.path, $event)">

                            <div class="fm-item-icon" style="text-align: center;">
                                <!--<i v-if="acl && file.acl === 0" class="fas fa-unlock-alt fa-5x pb-2"></i>-->
                                <v-btn v-show="hover" color="primary" v-on:click="downloadFile(file, $event)">
                                    Download
                                </v-btn>
                                <thumbnail v-show="!hover" v-if="thisImage(file.extension)"
                                           v-bind:disk="disk"
                                           v-bind:file="file">
                                </thumbnail>
                                <!--<i v-else class="far fa-5x pb-2"-->
                                <!--v-bind:class="extensionToIcon(file.extension)"></i>-->
                                <span v-show="!hover"  v-else class="fa-stack" v-bind:class="'bg-'+extensionToIcon(file.extension)">
                                  <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fas fa-stack-1x fa-inverse" v-bind:class="extensionToIcon(file.extension)"></i>
                                </span>
                            </div>
                            <div class="fm-grid-actions">
                                <v-btn @click="contextMenu(file, $event)" icon>
                                    <v-icon color="primary">more_vert</v-icon>
                                </v-btn>
                            </div>
                        </v-responsive>
                    </v-card>
                </v-hover>
                <div class="fm-item-info">
                    <!-- {{ `${file.filename}.${file.extension}` }} -->
                    {{ file.basename }}
                    <!--<br>-->
                    <!--{{-- bytesToHuman(file.size) --}}-->
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import translate from './../../mixins/translate';
import helper from './../../mixins/helper';
import managerHelper from './mixins/manager';
import Thumbnail from './Thumbnail.vue';

// These have to be included because we're doing download via the button.
import ContextMenu from '../blocks/mixins/contextMenu';
import ContextMenuActions from '../blocks/mixins/contextMenuActions';

export default {
  name: 'grid-view',
  components: { Thumbnail },
  mixins: [translate, helper, managerHelper, ContextMenu, ContextMenuActions],
  data() {
    return {
      disk: '',
    };
  },
  props: {
    manager: { type: String, required: true },
  },
  mounted() {
    this.disk = this.selectedDisk;
  },
  beforeUpdate() {
    // if disk changed
    if (this.disk !== this.selectedDisk) {
      this.disk = this.selectedDisk;
    }
  },
  computed: {
    hasContent() {
      return (this.files && this.files.length > 0) || (this.directories && this.directories.length > 0);
    },
    /**
             * Image extensions list
             * @returns {*}
             */
    imageExtensions() {
      return this.$store.state.fm.settings.imageExtensions;
    },
    singleFileView() {
      return this.$store.state.fm[this.manager].targetFile;
    },
    filteredFiles() {
      // I need to filter the files by those that match the file specified.
      const file = this.$store.state.fm[this.manager].targetFile;
      // Filter the files array based on the specified condition
      return this.files.filter(f => f.basename.includes(file));
    },
  },
  methods: {
    /**
     * Download shim for ContextMenu download functionality.
     * This isn't ideal, but the design calls for a button
     * on the grid.
     */
    downloadFile(file, $event) {
      this.selectItem('files', file.path, $event);
      this.downloadAction();
    },
    /**
             * Check file extension (image or no)
             * @param extension
             * @returns {boolean}
             */
    thisImage(extension) {
      // extension not found
      if (!extension) return false;

      return this.imageExtensions.includes(extension.toLowerCase());
    },
    returnToFileManager() {
      const baseUrl = window.location.origin + window.location.pathname;
      window.location = baseUrl;
    },
  },
};
</script>

<style lang="scss">
    .fm-grid {
        padding-top: 1rem;

    .fm-grid-item {
        position: relative;
        width: 125px;
        padding: 0.4rem;
        margin-bottom: 1rem;
        margin-right: 1rem;
        border-radius: 5px;

    &.active {
         background-color: #c2e5eb;
         box-shadow: 3px 2px 5px gray;
     }

    &:not(.active):hover {
         background-color: #f8f9fa;
         box-shadow: 3px 2px 5px gray;
     }

    .fm-item-icon{
        cursor: pointer;
    }

    .fm-item-icon > i,
    .fm-item-icon > figure > i {
        color: #6d757d;
    }

    .fm-item-info {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    }
    }
</style>
